import { Component, h, Prop } from '@stencil/core';
@Component({
  tag: 'vs-content-bundle-media',
})
export class ContentBundleMedia {
  @Prop() imgPath: string;
  @Prop() imgAltText: string;
  @Prop() hasVideo: string;
  @Prop() videoUrl: string;
  @Prop() videoTitle: string;
  @Prop() playBtnColor: string;
  @Prop() videoLayout: string;
  @Prop() videoPlayAriaValue: string;

  imgAltTextCleaned = '';


  render() {
    this.imgAltTextCleaned = this.imgAltText.toLowerCase() === 'na' ? '' : this.imgAltText;
    return (
      <div class="vs-content-bundle-media" data-video={this.hasVideo}>
        <img src={this.imgPath} alt={this.imgAltTextCleaned} class="vs-content-bundle-img vs-img-lazy" />
        {this.hasVideo === 'yes' ? (
          <vs-bundle-play-btn
            video-layout={this.videoLayout}
            play-btn-color={this.playBtnColor}
            video-url={this.videoUrl}
            video-title={this.videoTitle}
            thumbnail-path={this.imgPath}
            video-play-aria-value={this.videoPlayAriaValue}
          ></vs-bundle-play-btn>
        ) : (
          ''
        )}
      </div>
    );
  }
}
